import { render, staticRenderFns } from "./FilterItemComponent.vue?vue&type=template&id=67589808"
import script from "./FilterItemComponent.vue?vue&type=script&lang=js"
export * from "./FilterItemComponent.vue?vue&type=script&lang=js"
import style0 from "./FilterItemComponent.vue?vue&type=style&index=0&id=67589808&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports